import {createReducer} from "./index";
import * as R from 'ramda';
import {
  ADD_BID_COMMENTS,
  ADD_DAILY_LOG_COMMENTS, ADD_MEETING_MINUTES_COMMENTS,
  ADD_PROJECT_COMMENTS,
  ADD_PUNCH_LIST_COMMENTS,
  ADD_RFI_COMMENTS,
  ADD_SUBMITTAL_COMMENTS,
  ADD_TASK_COMMENTS
} from "../actions/comments";
import {ADD_NOTIFICATIONS} from "../actions/notifications";

// shape of the model
/*
data: {
  projects: {
    [projectid]: {
      data: [
        [id]: {
          item
        },
        [id]: {
          item
        },
      ],
    }
  }
}
 */

const initial = {
  data: {
    projects: {},
    bids: {},
    meetingminutes: {},
    dailylogs: {},
    punchlists: {},
    rfis: {},
    submittals: {},
    tasks: {},
  }
};

const addProjectComment = (projectId, chat, state) => R.set(R.lensPath(['data', 'projects', projectId, 'data', chat.id]), chat, state);
const addBidComment = (bidId, chat, state) => R.set(R.lensPath(['data', 'bids', bidId, 'data', chat.id]), chat, state);
const addMeetingMinutesComment = (meetingId, chat, state) => R.set(R.lensPath(['data', 'meetingminutes', meetingId, 'data', chat.id]), chat, state);
const addDailyLogComment = (logId, chat, state) => R.set(R.lensPath(['data', 'dailylogs', logId, 'data', chat.id]), chat, state);
const addPunchComment = (punchId, chat, state) => R.set(R.lensPath(['data', 'punchlists', punchId, 'data', chat.id]), chat, state);
const addRfiComment = (rfiId, chat, state) => R.set(R.lensPath(['data', 'rfis', rfiId, 'data', chat.id]), chat, state);
const addSubmittalComment = (submittalId, chat, state) => R.set(R.lensPath(['data', 'submittals', submittalId, 'data', chat.id]), chat, state);
const addTaskComment = (taskId, chat, state) => R.set(R.lensPath(['data', 'tasks', taskId, 'data', chat.id]), chat, state);

const associationTypeMap = {
  'project': addProjectComment,
  'bid': addBidComment,
  'meetingminutes': addMeetingMinutesComment,
  'dailylog': addDailyLogComment,
  'punchlistitem': addPunchComment,
  'projectrfi': addRfiComment,
  'submittal': addSubmittalComment,
  'task': addTaskComment,
};

const reducer = createReducer(initial,{
  [ADD_NOTIFICATIONS]: (state, action) => {
    const { notifications } = action.payload;
    for (let notification of notifications) {
      if (notification.segmenttype !== 'chat') continue;
      let addComment = associationTypeMap[notification.associationtype];
      if (addComment) {
        state = addComment(notification.associatedid, notification, state);
      }
    }
    return state;
  },
  [ADD_PROJECT_COMMENTS]: (state, action) => {
    const { projectId, chats } = action.payload;
    for (let chat of chats) {
      state = addProjectComment(projectId, chat, state);
    }
    return state;
  },
  [ADD_BID_COMMENTS]: (state, action) => {
    const { bidId, chats } = action.payload;
    for (let chat of chats) {
      state = addBidComment(bidId, chat, state);
    }
    return state;
  },
  [ADD_MEETING_MINUTES_COMMENTS]: (state, action) => {
    const { meetingId, chats } = action.payload;
    for (let chat of chats) {
      state = addMeetingMinutesComment(meetingId, chat, state);
    }
    return state;
  },
  [ADD_DAILY_LOG_COMMENTS]: (state, action) => {
    const { logId, chats } = action.payload;
    for (let chat of chats) {
      state = addDailyLogComment(logId, chat, state);
    }
    return state;
  },
  [ADD_PUNCH_LIST_COMMENTS]: (state, action) => {
    const { punchId, chats } = action.payload;
    for (let chat of chats) {
      state = addPunchComment(punchId, chat, state);
    }
    return state;
  },
  [ADD_RFI_COMMENTS]: (state, action) => {
    const { rfiId, chats } = action.payload;
    for (let chat of chats) {
      state = addRfiComment(rfiId, chat, state);
    }
    return state;
  },
  [ADD_SUBMITTAL_COMMENTS]: (state, action) => {
    const { submittalId, chats } = action.payload;
    for (let chat of chats) {
      state = addSubmittalComment(submittalId, chat, state);
    }
    return state;
  },
  [ADD_TASK_COMMENTS]: (state, action) => {
    const { taskId, chats } = action.payload;
    for (let chat of chats) {
      state = addTaskComment(taskId, chat, state);
    }
    return state;
  },
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/comments.js